import { Checkbox } from "@design-system/shadcn";
import React, { useMemo, useCallback } from "react";

import { useFieldContext } from "../core/form-contexts";

type FormFieldCheckboxProps = Omit<
  React.ComponentProps<typeof Checkbox>,
  "name" | "hasError" | "checked" | "onCheckedChange"
>;

function FormFieldCheckbox(props: FormFieldCheckboxProps) {
  const field = useFieldContext<boolean>();

  if (!field) {
    throw new Error("FormFieldCheckbox must be used within form.AppField");
  }

  const hasError = useMemo(
    () => field.state.meta.errors.length > 0,
    [field.state.meta.errors.length]
  );
  const changeHandler = useCallback(
    (value: boolean) => field.handleChange(value),
    [field]
  );

  return (
    <Checkbox
      name={field.name}
      aria-invalid={hasError}
      checked={field.state.value}
      onCheckedChange={changeHandler}
      {...props}
    />
  );
}

export { FormFieldCheckbox };
export type { FormFieldCheckboxProps };
